import { render, staticRenderFns } from "./absenteeism.vue?vue&type=template&id=d00d3fce&scoped=true&"
import script from "./absenteeism.vue?vue&type=script&lang=js&"
export * from "./absenteeism.vue?vue&type=script&lang=js&"
import style0 from "./absenteeism.vue?vue&type=style&index=0&id=d00d3fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00d3fce",
  null
  
)

export default component.exports